import React,{useRef,useEffect} from 'react';  
 
  import GifGrid from '../components/GifGrid'
  import CheckItOut from '../components/CheckItOut'
import { Divider } from 'semantic-ui-react';
 
  function DualClass(props){ 

      const header = <div><i>Cascade Tactics</i> has a dual-class system and combinations provide interesting synergy</div>
      const subtext = <div>Each character can choose two classes and attain the abilities and stats of each.  Some abilities can be combined with others to change how they behave. Below are just a few examples. </div>
      return   <div> <GifGrid
        width={props.width}
        height={props.height}
        headerText ={header}
        headerSubText = {subtext}
        gifData={[
          {headerText:"A Sentinel can guard designated tiles with his weapon", gif:"GuardWeapon1.gif"},
          {headerText:"Or he can guard with one of his abilities. A Sentinel/Ice Mage can do the following: ", gif:"GuardIcePrison1.gif"},
          {headerText:"A Lancer can add cast time to his weapon to deal more damage", gif:"ChargeWeapon1.gif"},
          {headerText:"A Lancer/Pyromancer can add cast time to increase area of Flames", gif:"ChargeFlames.gif"},
          {headerText:"A Commander can issue actions to allies.", gif:"CommandAttack1.gif"},
          {headerText:"A Commander/Pyromancer can issue allies to cast any Pyromancer ability", gif:"CommandFlames1.gif"},
          {headerText:"A Sorcerer/Paladin can cast a Paladin ability twice", gif:"DoubleCast.gif"},
          {headerText:"An Archer/Ice Mage can cast Ice Prison after a successful hit", gif:"InfuseIcePrison1.gif"},
          {headerText:"A Necromancer can raise a skeleton when a character dies", gif:"UponDeathReanimate1.gif"},
          {headerText:"A Necromancer/Pyromancer can cast Flames upon the death of a character", gif:"UponDeathFlames1.gif"},

        ]}
      > 
      </GifGrid> 
      <Divider></Divider>
      <CheckItOut hiddenButton='dualclass'></CheckItOut>
      </div>
  }
  
export default DualClass;